<template>
  <div id="printTable" v-show="isPrintingTable">
    <ReportHeader>{{ staffName }} Workers Comp </ReportHeader>
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="printHeaders"
          :items="items"
          hide-default-footer
          disable-pagination
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ReportHeader from "@/components/Report/ReportHeader.vue";

export default {
  props: {
    printHeaders: {
      type: Array,
    },
    items: {
      type: Array,
    },
    staffName: {
      type: String,
    },
    isPrintingTable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ReportHeader,
  },
};
</script>
